<div
  class="d-flex justify-content-center align-items-center height d-flex flex-column">
  <mat-icon class="logo-icon text"> credit_card</mat-icon>
  <p class="h5 text pt-2 font-weight-bold">
    {{ 'withdraw.alertPendingAccount' | translate }}
  </p>
</div>
